import type { Category } from '../../sharedTypes';

export const CATEGORIES = {
  RECEIVE_CATEGORIES: 'categories/receive_categories',
};

export type ReceiveCategoriesAction = {
  type: typeof CATEGORIES.RECEIVE_CATEGORIES;
  categories: Array<Category>;
};

export function receiveCategories(categories: Array<Category>): ReceiveCategoriesAction {
  return {
    type: CATEGORIES.RECEIVE_CATEGORIES,
    categories,
  };
}
